<template>
  <router-link
    tag="div"
    :to="{ name: 'ModelProfile', params: { gender: $route.params.gender, name: editedName}, query: { id: id }}"
    class="model-card"
  >
    <div class="model-card__image-container">
      <img class="model-card__image" loading="lazy" :src="image" :alt="name">
      <div class="model-card__overlay"></div>
    </div>
    <p class="model-card__name">{{ name }}</p>
  </router-link>
</template>

<script>
export default {
  name: 'ModelCard',
  props: {
    id: {
      required: true,
      type: String
    },
    name: {
      required: true,
      type: String
    },
    image: {
      required: true,
      type: String
    }
  },
  computed: {
    editedName() {
      return this.name.replace(/\s+/, "_")
    }
  }
}
</script>

<style lang="scss" scoped>
@use "../styles/fonts";
@use "../styles/colors";

.model-card {
  @include fonts.ap-reg;
  font-size: 13px;
  cursor: pointer;
  &:hover &__overlay {
    opacity: 0.4;
  }
  &__image-container {
    position: relative;
    padding-bottom: 128%;
  }
  &__image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    background-color: colors.$grayef;
  }
  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    background-color: #000;
    transition: 200ms opacity ease;
  }
  &__name {
    text-transform: uppercase;
    margin-top: 12px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>